import { useTranslations } from "next-intl";

import { Card } from "@/components/ui";
import { ShowMore } from "@/ui/Common/ShowMore";

interface ObjectDetailDescriptionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  description: string;
}

export const ObjectDetailDescription = ({
  description,
  className,
}: ObjectDetailDescriptionProps) => {
  const t = useTranslations();

  return (
    <section className={className}>
      <h2 className={"object-detail__section-header mb-[3rem]"}>
        {t("Description")}
      </h2>
      <Card className={"xl:p-12 text-md"}>
        {description && (
          <ShowMore
            buttonClassName="text-gray-1200"
            maxHeight={210}
            titleCollapsed={t("Learn more")}
            titleExpanded={t("Collapse")}
          >
            <pre
              className={
                "font-geometria whitespace-pre-wrap break-words text-pretty"
              }
            >
              {description}
            </pre>
          </ShowMore>
        )}

        {!description && <p> &mdash; </p>}
      </Card>
    </section>
  );
};
